import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { BottomSheetBody } from "@opensea/ui-kit";
import { TransactionFullScreen } from "../../../../../components/TransactionFullScreen";
import { TransferFlowDone_itemFragment } from "./TransferFlowDone.fragment";
export const TransferFlowDone = t0 => {
  const $ = _c(15);
  const {
    title,
    body,
    items: itemKeys,
    withError
  } = t0;
  let T0;
  let T1;
  let t1;
  let t2;
  if ($[0] !== body || $[1] !== itemKeys) {
    const items = itemKeys.map(_temp);
    T1 = BottomSheetBody;
    T0 = TransactionFullScreen;
    t1 = body;
    t2 = items.map(_temp2);
    $[0] = body;
    $[1] = itemKeys;
    $[2] = T0;
    $[3] = T1;
    $[4] = t1;
    $[5] = t2;
  } else {
    T0 = $[2];
    T1 = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  let t3;
  if ($[6] !== T0 || $[7] !== t1 || $[8] !== t2 || $[9] !== title || $[10] !== withError) {
    t3 = <T0 body={t1} images={t2} monochrome={withError} title={title} />;
    $[6] = T0;
    $[7] = t1;
    $[8] = t2;
    $[9] = title;
    $[10] = withError;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== T1 || $[13] !== t3) {
    t4 = <T1>{t3}</T1>;
    $[12] = T1;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
};
function _temp(item) {
  return readFragment(TransferFlowDone_itemFragment, item);
}
function _temp2(item_0) {
  return item_0.imageUrl ?? "";
}